/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Export_Complete_TitleInputs */

const en_ateliere_connect_export_complete_title = /** @type {(inputs: Ateliere_Connect_Export_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Complete`)
};

const fr_ateliere_connect_export_complete_title = /** @type {(inputs: Ateliere_Connect_Export_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation terminée`)
};

const de_ateliere_connect_export_complete_title = /** @type {(inputs: Ateliere_Connect_Export_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export abgeschlossen`)
};

const it_ateliere_connect_export_complete_title = /** @type {(inputs: Ateliere_Connect_Export_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione completata`)
};

const ru_ateliere_connect_export_complete_title = /** @type {(inputs: Ateliere_Connect_Export_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт завершен`)
};

const es_ateliere_connect_export_complete_title = /** @type {(inputs: Ateliere_Connect_Export_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación completa`)
};

const zh_cn2_ateliere_connect_export_complete_title = /** @type {(inputs: Ateliere_Connect_Export_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出完成`)
};

const ja_ateliere_connect_export_complete_title = /** @type {(inputs: Ateliere_Connect_Export_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポート完了`)
};

const hi_ateliere_connect_export_complete_title = /** @type {(inputs: Ateliere_Connect_Export_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात पूर्ण`)
};

const pt_pt2_ateliere_connect_export_complete_title = /** @type {(inputs: Ateliere_Connect_Export_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação concluída`)
};

/**
* | output |
* | --- |
* | "Export Complete" |
*
* @param {Ateliere_Connect_Export_Complete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_export_complete_title = /** @type {((inputs?: Ateliere_Connect_Export_Complete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Export_Complete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ateliere_connect_export_complete_title(inputs)
	if (locale === "de") return de_ateliere_connect_export_complete_title(inputs)
	if (locale === "it") return it_ateliere_connect_export_complete_title(inputs)
	if (locale === "ru") return ru_ateliere_connect_export_complete_title(inputs)
	if (locale === "es") return es_ateliere_connect_export_complete_title(inputs)
	if (locale === "zh-CN") return zh_cn2_ateliere_connect_export_complete_title(inputs)
	if (locale === "ja") return ja_ateliere_connect_export_complete_title(inputs)
	if (locale === "hi") return hi_ateliere_connect_export_complete_title(inputs)
	if (locale === "pt-PT") return pt_pt2_ateliere_connect_export_complete_title(inputs)
	return en_ateliere_connect_export_complete_title(inputs)
});